import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jwhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
  <title>Java while loop tutorial For Beginners</title>
<meta name="description" content="Java while loop tutorial for beginners.This condition will be given and the body of the loop will be executed until the given condition is false" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java while,java while do,java while loop example,java while true,java while loop break,java while loop continue,java while continue,java while break,java while example,java while else,java while condition,java while 1
,java while loop user input,java while loop programs,java while readline" />
<link rel="canonical" href="https://www.codeexampler.com/java-while" />
</Helmet>


<div className='lg:pl-56'>

    <h1 className="m-4 mh1">while loop in Java</h1>
    <div className="first">
        <a href="/java-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">While loop for Java:</h2>
    <p className="mt-4 para">This condition will be given and the body of the loop will be executed until the given condition is false</p>



<h2 className="headings">while loop Java Syntax:</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            {"\n"}
      <span className="qwerty-8">while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;Statement</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
    
      {"\n"}
      <span className="qwerty-2">&nbsp;Body</span>
          {"\n"}
      <span className="qwerty-3">&#125; </span>
    
    {"\n"}  {"\n"}
        
            </code>
          </pre>        
        </div>

     


<h2 className="mt-4 mh2">Addition or Increment in While Loop</h2>




<h2 className="headings">Q-Write a Program Addition or Increment in while loop Java Examples?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> Whileloop_example</span>
              
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
      
    
              
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">1;</span>
          {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;=</span>  
      <span className="qwerty-1">10</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
    
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty-8">++;</span>
          <span className="qwerty-5">{`// OR a=a+1`}</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
     {"\n"}
              <span className="qwerty-3">&#125; </span>
                {"\n"}  {"\n"}
         </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">1</span>
              {"\n"}
              <span className="qwerty-5">2</span>
              {"\n"}
              <span className="qwerty-5">3</span>
              {"\n"}
              <span className="qwerty-5">4</span>
              {"\n"}
              <span className="qwerty-5">5</span>
              {"\n"}
              <span className="qwerty-5">6</span>
              {"\n"}
              <span className="qwerty-5">7</span>
              {"\n"}
              <span className="qwerty-5">8</span>
              {"\n"}
              <span className="qwerty-5">9</span>
              {"\n"}
              <span className="qwerty-5">10</span>
              {"\n"}
              
           
                </code>{"   "}
                </pre>
          </div>
        </div>




<h2 className="mt-4 mh2">Subtraction or decrement in While Loop</h2>



<h2 className="headings">Q-Write a Program decrement or Subtract in a while loop for Java?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> Whileloop_example</span>
              
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
      
    
              
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">10;</span>
          {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#62;</span>  
      <span className="qwerty-1">1</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
    
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty-8">--;</span>
          <span className="qwerty-5">{`// OR a=a-1`}</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
    {"\n"}
              <span className="qwerty-3">&#125; </span>
                {"\n"}  {"\n"}
        
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">10</span>
              {"\n"}
              <span className="qwerty-5">9</span>
              {"\n"}
              <span className="qwerty-5">8</span>
              {"\n"}
              <span className="qwerty-5">7</span>
              {"\n"}
              <span className="qwerty-5">6</span>
              {"\n"}
              <span className="qwerty-5">5</span>
              {"\n"}
              <span className="qwerty-5">4</span>
              {"\n"}
              <span className="qwerty-5">3</span>
              {"\n"}
              <span className="qwerty-5">2</span>
              {"\n"}
              <span className="qwerty-5">1</span>
              {"\n"}
              
           
                </code>{"   "}
                </pre>
          </div>
        </div>

<h2 className="mt-4 mh2">While loop Reverse in Java:</h2>


<h2 className="headings">Q-Write a Program to input an integer number and print in reverse?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> Whileloop_example</span>
              
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
      
    
              
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">2560;</span>
          {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#62;</span>  
      <span className="qwerty-1">0</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
    
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
          <span className="qwerty-1">);</span>
          {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8">%</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-8">/</span>
          <span className="qwerty-4">10</span>
          <span className="qwerty-1">);</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
    
    {"\n"}
              <span className="qwerty-3">&#125; </span>
                {"\n"}  {"\n"}
        
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">2560</span>
              {"\n"}
              
           
                </code>{"   "}
                </pre>
          </div>
        </div>




<h2 className="headings">Q-write a Program to input find out the sum of digits of integer no?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Whileloop_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">2560 ,</span>
      <span className="qwerty-4">sum</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">0;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#62;</span>  
  <span className="qwerty-1">0</span>   
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}

  
  <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sum</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-4">sum</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4">a;</span>
      {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">/</span>
      <span className="qwerty-4">10;</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"sum of Digits="</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">sum</span>
      <span className="qwerty-1">);</span>
      {"\n"}
 <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
    </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;sum of Digits </span>          
          <span className="qwerty-8">=</span>
          <span className="qwerty-5">2843</span>
          {"\n"}  
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div> 
        </div>
    </div>
)

}
export default Jwhile;